import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { gmWelfareLevelAdd, gmWelfareLevelUpd } from '@/api/gmtool/packageCode';
import { gmTool } from "@/mixins/index";
export default {
  mixins: [gmTool],
  props: {
    prod: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    serverList: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      paramsData: {
        id: '',
        name: '',
        amount_limit: '',
        refresh_interval: ''
      },
      dialogShow: false,
      rules: {
        name: [{
          required: true,
          message: this.$t('pleaseInput'),
          trigger: "blur"
        }],
        amount_limit: [{
          required: true,
          message: this.$t('pleaseInput'),
          trigger: "blur"
        }],
        refresh_interval: [{
          required: true,
          message: this.$t('pleaseInput'),
          trigger: "blur"
        }]
      }
    };
  },
  created: function created() {},
  methods: {
    open: function open(data) {
      if (data) {
        this.paramsData = _objectSpread(_objectSpread({}, this.paramsData), data);
      }

      this.dialogShow = true;
    },
    clearData: function clearData(isClearId) {
      this.paramsData = {
        id: isClearId ? '' : this.paramsData.id,
        name: '',
        amount_limit: '',
        refresh_interval: ''
      };
      this.$refs.ruleForm.clearValidate();
    },
    dataFormSubmit: function dataFormSubmit() {
      var _this = this;

      this.$refs.ruleForm.clearValidate();
      this.$refs.ruleForm.validate(function (valid) {
        if (valid) {
          var reqFn = _this.paramsData.id !== '' ? gmWelfareLevelUpd : gmWelfareLevelAdd;
          reqFn(_objectSpread(_objectSpread({}, _this.paramsData), _this.prod)).then(function (res) {
            if (res.status == 200) {
              _this.$message({
                message: _this.$t('operationSuccess'),
                type: 'success'
              });

              _this.dialogShow = false;

              _this.$emit('update');
            }
          });
        }
      });
    }
  }
};